export default __webpack_public_path__ + "static/media/cancel.fcd3e98c.svg";